var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.93548C5.54609 1.93548 1.93548 5.54609 1.93548 10C1.93548 14.4539 5.54609 18.0645 10 18.0645C14.4539 18.0645 18.0645 14.4539 18.0645 10C18.0645 5.54609 14.4539 1.93548 10 1.93548ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7202 6.52344C11.7202 7.51582 10.9501 8.32031 10.0001 8.32031C9.05016 8.32031 8.28005 7.51582 8.28005 6.52344C8.28005 5.53105 9.05016 4.72656 10.0001 4.72656C10.9501 4.72656 11.7202 5.53105 11.7202 6.52344Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3558 9.46664L11.6332 14.7791C11.6472 15.0477 11.4426 15.2734 11.1852 15.2734L8.8151 15.2734C8.55769 15.2734 8.35304 15.0477 8.36706 14.7791L8.64444 9.46664C8.65742 9.21805 8.85418 9.02344 9.09249 9.02344L10.9078 9.02344C11.1461 9.02344 11.3428 9.21805 11.3558 9.46664Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0510fe690d84b1c00bb513e2309fcc53.svg";
export { ForwardRef as ReactComponent };